export default {
    sanitisePhoneNumber(number) {
        number = number.split(' ').join('');
        return number;
    },
    validPhoneNumber(number) {
        if(number.includes("+") || number.includes("-")){
            return false;
        }

        if(!isNaN(number) && number.length >= 10 && number.length <= 14) {
            return true;
        }

        return false;
    }
}